module.exports = __webpack_public_path__ + "img/bp_yq1_dis.68547bfa.png";